<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>

    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">時段</label>
              <el-select
                style="display: block"
                v-model="search.TimePeriod"
                placeholder="請選擇"
                clearable
              >
                <el-option
                  :key="option.Value"
                  :label="option.Text"
                  v-for="option in timePeriodOptions"
                  :value="option.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">應徵職務</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.ManpowerDemandName"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">招募窗口</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.ContactPerson"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">面試狀態</label>
              <el-select
                style="display: block"
                v-model="search.IsFinish"
                placeholder="請選擇"
                clearable
              >
                <el-option label="全部" :value="null"> </el-option>
                <el-option label="未結案" :value="false"> </el-option>
                <el-option label="已結案" :value="true"> </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">姓名</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.Name"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <button
              @click="getFlowManage()"
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-right: 5px"
            >
              {{ i18n("Buttons.Search") }}
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-right: 5px"
              @click="search = {}"
            >
              清除
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right">
      更新時間:{{ reloadTime }}
    </div>
    <div class="fixed-list-item">
      <eva-icon fill="#000" name="refresh-outline" @click="reload" />
    </div>
    <div class="text-right">
      <span style="position: relative; bottom: -30px">共計{{ personList.length }}人</span>
    </div>
    <el-tabs v-model="activeName" @tab-click="getFlowManage">
      <el-tab-pane label="全部" name="All"> </el-tab-pane>
      <el-tab-pane label="IDL" name="IDL"></el-tab-pane>
      <el-tab-pane label="DL" name="DL"> </el-tab-pane>
    </el-tabs>

    <div class="process-list">
      <div class="p-row" v-for="(person, personIndex) in personList" :key="personIndex">
        <div class="info">
          <el-tooltip effect="dark" :content="person.Name" placement="top-start">
            <div
              class="name-link"
              :class="{
                female: person.Sex === '女',
                male: person.Sex === '男',
              }"
              @click="showDetailModal(person)"
            >
              {{ person.Name }}
            </div>
          </el-tooltip>

          <div class="id">{{ person.IdNo }}</div>

          <el-tooltip
            effect="dark"
            :content="person.ManpowerDemandName"
            placement="top-start"
            style="margin-bottom: 5px"
          >
            <span class="job">{{ person.ManpowerDemandName }}</span>
          </el-tooltip>

          <el-tag
            v-for="(item, index) in person.ExpireStatus"
            :key="index"
            :type="item === '超時' || item === '整體流程超時' ? 'danger' : 'warning'"
            ><eva-icon
              width="20"
              name="alert-circle-outline"
              fill="#FF0000"
              style="position: relative; top: -2px"
            ></eva-icon
            >{{ item }}</el-tag
          >
        </div>

        <div class="flow">
          <ul class="flow-group">
            <li class="flow-item forbid">
              <span class="step-name">報到</span>
              <div>{{ person.CheckInTime | momentTime }}</div>
            </li>
          </ul>

          <!-- 未完成的步驟 -->
          <draggable
            ghost-class="ghost"
            tag="ul"
            v-model="person.Stages"
            class="flow-group"
            draggable=".flow-item:not(.forbid)"
            @end="onEnd($event, person.Guid, personIndex)"
            :move="handleMove"
          >
            <div
              class="flow-item"
              :class="{
                undo: step.Status === 1,
                meeting: step.Status === 2,
                finish: step.Status === 3 || person.FinishTime || step.IsDeleted,
                forbid:
                  step.Status === 2 ||
                  step.Status === 3 ||
                  person.FinishTime ||
                  step.IsDeleted,
              }"
              v-for="(step, stepIndex) in person.Stages"
              :key="step.StageGuid"
            >
              <el-tooltip class="text" effect="dark" :content="step.Name" placement="top">
                <span class="step-name" :class="{ 'line-through': step.IsDeleted }">{{
                  step.Name
                }}</span>
              </el-tooltip>

              <el-select
                style="width: 100px"
                filterable
                v-model="step.InterviewSupervisorGuid"
                v-if="step.Type === 2"
                :disabled="step.StartTime !== null || step.IsDeleted"
                @visible-change="setTempSupervisor($event, step.InterviewSupervisorGuid)"
                @change="
                  changeSupervisor(
                    $event,
                    person.Guid,
                    step.StageGuid,
                    personIndex,
                    stepIndex
                  )
                "
              >
                <el-option
                  :value="interviewPerson.Value"
                  :key="interviewPerson.Value"
                  :label="interviewPerson.Text"
                  v-for="interviewPerson in supervisorList"
                ></el-option>
              </el-select>

              <div>
                <div class="time-wrap" v-if="step.Status !== 1">
                  {{ step.StartTime | momentTime }}
                  <span v-if="step.Name !== '報到'">~</span>

                  <span style="opacity: 0.6" v-if="step.Status === 2">{{
                    step.ExpectEndTime | momentTime
                  }}</span>

                  {{ step.EndTime | momentTime }}

                  <el-button
                    v-if="step.Status === 2"
                    type="danger"
                    size="mini"
                    @click="endArrange(person.Guid, personIndex, step.StageGuid)"
                    round
                    >結束</el-button
                  >
                </div>

                <template v-if="!person.FinishTime && !step.IsDeleted">
                  <el-button
                    v-if="step.CanStart"
                    type="primary"
                    size="mini"
                    @click="startArrange(person.Guid, personIndex, step.StageGuid)"
                    round
                    >開始</el-button
                  >
                  <el-button
                    v-if="step.Status === 1"
                    type="info"
                    size="mini"
                    @click="
                      openPassModal(person.Guid, step.StageGuid, personIndex, step.Name)
                    "
                    round
                    >Pass</el-button
                  >

                  <el-button
                    v-if="step.Status === 2"
                    type="warning"
                    size="mini"
                    @click="cancelArrange(person.Guid, personIndex, step.StageGuid)"
                    round
                    >取消</el-button
                  >
                </template>

                <el-tag
                  v-for="(item, index) in step.ExpireStatus"
                  :key="index"
                  :type="
                    item === '超時' || item === '整體流程超時' ? 'danger' : 'warning'
                  "
                  ><eva-icon
                    width="20"
                    name="alert-circle-outline"
                    fill="#FF0000"
                    style="position: relative; top: -2px"
                  ></eva-icon
                  >{{ item }}</el-tag
                >
              </div>
            </div>
          </draggable>
          <el-button
            v-if="!person.FinishTime"
            style="vertical-align: middle; margin-left: 5px"
            @click="selectStage(person, personIndex)"
            icon="el-icon-plus"
            size="mini"
            circle
          >
          </el-button>
          <ul class="flow-group">
            <li class="flow-item">
              <span class="step-name" v-if="person.CancelReason == null">結案</span>
              <span class="step-name" v-else-if="person.CancelReason == '轉推薦'">轉推薦</span>
              <span class="step-name" v-else>強制結案</span>
              <br />
              <div class="time-wrap" v-if="person.FinishTime">
                {{ person.FinishTime | momentTime }}
              </div>
              <template v-if="!person.FinishTime">
                <el-button
                  v-if="hasUndo(person.Stages)"
                  type="danger"
                  size="mini"
                  @click="showDangerEndModal(person, personIndex)"
                  round
                  >強制結案</el-button
                >
                <el-button
                  v-else
                  type="primary"
                  size="mini"
                  @click="showEndModal(person, personIndex)"
                  round
                  >結案</el-button
                >

                <el-button
                  type="primary"
                  size="mini"
                  @click="showTransferModal(person, personIndex)"
                  round
                  >轉推薦</el-button
                >
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 取消 Modal -->
    <div
      class="modal fade"
      id="alertModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">是否確定取消</h5>
          </div>
          <div class="modal-body text-center"></div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              關閉
            </button>
            <button type="button" @click="cancel(currentPerson)" class="btn btn-primary">
              確定
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 結案 Modal -->
    <div
      class="modal fade"
      id="endModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">結案</h5>
          </div>
          <div class="modal-body">
            <span>處理內容</span>
            <el-input
              type="textarea"
              style="width: 100%"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="請輸入內容"
              v-model="cancelModal.FinishRemark"
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="finishArrange('normal')"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 強制結案 Modal -->
    <div
      class="modal fade"
      id="dangerEndModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver v-slot="{ handleSubmit }">
            <div class="modal-header">
              <h5 class="modal-title">是否強制結案</h5>
            </div>
            <div class="modal-body">
              <span><span class="mark">*</span>結案原因</span>
              <ValidationProvider
                class="w-100"
                name="結案原因"
                v-slot="{ errors }"
                rules="required"
              >
                <el-select
                  style="width: 100%"
                  v-model="cancelModal.cancelReason"
                  placeholder="請選擇"
                >
                  <el-option
                    v-for="option in cancelReasonList"
                    :key="option.Value"
                    :label="option.Text"
                    :value="option.Value"
                  >
                  </el-option>
                </el-select>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
              <br /><br />
              <span>備註</span>
              <el-input
                type="textarea"
                style="width: 100%"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="請輸入內容"
                v-model="cancelModal.FinishRemark"
                maxlength="500"
                show-word-limit
              >
              </el-input>
            </div>
            <div class="modal-footer">
              <button type="reset" class="btn btn-secondary" data-dismiss="modal">
                關閉
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="handleSubmit(finishArrange)"
              >
                確定
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- 強制結案 Modal -->
    <div
      class="modal fade"
      id="transferModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver ref="transferModalForm" v-slot="{ handleSubmit }">
            <div class="modal-header">
              <h5 class="modal-title">轉推薦</h5>
            </div>
            <div class="modal-body">
              <div><span class="mark">*</span>職務</div>

              <ValidationProvider
                class="w-100"
                name="職務"
                v-slot="{ errors }"
                rules="required"
              >
                <el-select
                  style="width: 100%"
                  v-model="transferModal.ManpowerDemandNo"
                  filterable
                  clearable
                  placeholder="請選擇"
                >
                  <el-option
                    v-for="item in positionOptions"
                    :key="item.Value"
                    :label="item.Text"
                    :value="item.Value"
                  >
                  </el-option>
                </el-select>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>

              <div style="margin-top: 10px"><span class="mark">*</span>流程</div>

              <ValidationProvider
                class="w-100"
                name="流程"
                v-slot="{ errors }"
                rules="required"
              >
                <el-select
                  style="width: 100%"
                  v-model="transferModal.BaseFlowGuid"
                  placeholder="請選擇"
                >
                  <el-option
                    v-for="item in flowOptions"
                    :key="item.Value"
                    :label="item.Text"
                    :value="item.Value"
                    :disabled="!item.IsEnabled"
                  >
                  </el-option>
                </el-select>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
              <div style="margin-top: 10px">接待窗口</div>
              <el-select
                style="width: 100%"
                filterable
                clearable
                v-model="transferModal.ContactPersonGuid"
                placeholder="請選擇窗口"
              >
                <el-option
                  v-for="item in contactOptions"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                >
                </el-option>
              </el-select>

              <div style="margin-top: 10px"><span class="mark">*</span>HR主管</div>

              <ValidationProvider
                class="w-100"
                name="HR主管"
                v-slot="{ errors }"
                rules="required"
              >
                <el-select
                  style="width: 100%"
                  filterable
                  v-model="transferModal.HrSupervisorGuid"
                  placeholder="請選擇"
                >
                  <el-option
                    v-for="item in contactOptions"
                    :key="item.Value"
                    :label="item.Text"
                    :value="item.Value"
                  >
                  </el-option>
                </el-select>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>

              <div style="margin-top: 10px">面談主管</div>
              <el-select
                style="width: 100%"
                filterable
                clearable
                v-model="transferModal.ManagerSupervisorGuid"
                placeholder="請選擇窗口"
              >
                <el-option
                  v-for="item in contactOptions"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="modal-footer">
              <button type="reset" class="btn btn-secondary" data-dismiss="modal">
                關閉
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="handleSubmit(saveTransfer)"
              >
                確定
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- pass Modal -->
    <div
      class="modal fade"
      id="passModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">pass</h5>
          </div>
          <div class="modal-body">
            是否確認pass<span style="font-weight: bold; color: #ff0000">{{
              passItem.stepName
            }}</span
            >階段?
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              取消
            </button>
            <button type="button" @click="pass()" class="btn btn-primary">確定</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 加入階段 Modal -->
    <div
      class="modal fade"
      id="stepModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">加入階段</h5>
          </div>
          <div class="modal-body">
            <span>階段</span>
            <el-select style="width: 100%" v-model="extraStage" placeholder="請選擇">
              <el-option
                v-for="item in stageList"
                :label="item.Text"
                :value="item.Value"
                :key="item.Value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              關閉
            </button>
            <button type="button" @click="addStage()" class="btn btn-primary">
              確定
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a>
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>

            <div class="close-show-detail" @click.prevent="isShowDetail = !isShowDetail">
              <eva-icon name="close-circle" fill="#FFF" width="50" height="50"></eva-icon>
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar class="page">
                <section class="page-inner">
                  <div class="title">
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="
                          $common.downloadResumePDF(
                            resumeDetail.ResumeType,
                            resumeDetail.ResumeId
                          )
                        "
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="resumeDetail.ResumeType === 'IDL'"
                    :ResumeId="resumeDetail.ResumeId"
                    :ResumeType="'IDL'"
                  />
                  <DlResume
                    v-if="resumeDetail.ResumeType === 'DL'"
                    :ResumeId="resumeDetail.ResumeId"
                    :ResumeType="'DL'"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global $ */
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
import draggable from "vuedraggable";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "RoomScheduleSetting",

  components: {
    draggable,
    IdlResume,
    DlResume,
  },
  data() {
    return {
      passItem: {},
      reloadTime: null, //重新刷新的時間
      textarea2: null,
      currentPerson: null,
      activeName: "All",
      cancelModal: {}, //結案modal
      cancelReasonList: [], //結案原因
      personList: [],
      timePeriodOptions: [],

      resumeDetail: {},
      isShowDetail: false,

      stageList: [],
      search: {
        period: null,
        status: null,
      },
      extraStage: null, //加入的階段
      supervisorList: [], //面談人員

      tempSupervisor: null,

      //轉推薦
      transferModal: {},
      flowOptions: [],
      contactOptions: [],
      positionOptions: [],
    };
  },

  methods: {
    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    //vuedraggable 移動method
    handleMove(e) {
      //滿意度問券不能移動 & 卡在最後一項
      const disableSortStageName = "滿意度問卷";
      if (
        e.draggedContext.element.Name === disableSortStageName ||
        e.relatedContext.index === e.relatedContext.list.length - 1
      )
        return false;
    },

    //move回调方法
    onEnd(e, Guid, personIndex) {
      let currentStage = JSON.parse(JSON.stringify(e.item._underlying_vm_));

      if (currentStage.Seq === e.newIndex + 1) {
        return false; //如果沒拖拉就不動
      } else {
        let params = {
          ArrangeGuid: Guid,
          StageGuid: currentStage.StageGuid,
          Seq: e.newIndex + 1,
        };

        const vm = this;
        vm.$api.InterviewSch.moveArrange(params)
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
              return false;
            } else {
              vm.personList.splice(personIndex, 1, response.data.Data.FlowManage);
              vm.$notify({
                message: response.data.Data.Message,
                type: "success",
              });
            }
          })
          .catch((error) => {
            this.$notify({
              message: error.response.data.ErrorMessage,
              type: "error",
            });
            return false;
          });
      }
    },

    //檢查是不是有未完成項目 1 = 未開始 2 = 進行中，如果有就顯示強制結案，否則顯示結案
    hasUndo(Stages) {
      const result = Stages.some((item) => {
        return item.Status === 1 || item.Status === 2;
      });

      return result;
    },

    // 檢視履歷
    showDetailModal(person) {
      const vm = this;
      vm.resumeDetail = {
        ResumeType: person.ResumeType,
        ResumeId: person.ResumeId,
      };

      this.isShowDetail = true;
    },

    reload() {
      //重新讀取
      const today = new Date();
      const hour = today.getHours();
      const min = today.getMinutes();
      const sec = today.getSeconds();

      // 轉成字串，如果低於10，前面加上'0'
      const hourString = hour < 10 ? "0" + hour : "" + hour;
      const minString = min < 10 ? "0" + min : "" + min;
      const secString = sec < 10 ? "0" + sec : "" + sec;

      this.reloadTime = hourString + ":" + minString + ":" + secString;
      this.getFlowManage();
    },
    close(person) {
      let doing = person.doing;
      doing.endTime = this.dayjs().format("HH:mm");
      person.doneList.push(doing);
      person.doing = null;
    },
    //開始階段
    startArrange(id, personIndex, stageGuid) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.startArrange(id, stageGuid)
        .then((response) => {
          if (response.data.ErrorMessage) {
            vm.$store.dispatch("updateLoading", false);
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.personList.splice(personIndex, 1, response.data.Data.FlowManage);
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              message: response.data.Data.Message,
              type: "success",
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    //結案階段
    endArrange(id, personIndex, stageGuid) {
      const vm = this;
      vm.$api.InterviewSch.endArrange(id, stageGuid)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.personList.splice(personIndex, 1, response.data.Data.FlowManage);
            vm.$notify({
              message: response.data.Data.Message,
              type: "success",
            });
          }
        })
        .catch((error) => {
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    cancelArrange(id, personIndex, stageGuid) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.cancelArrange(id, stageGuid)
        .then((response) => {
          if (response.data.ErrorMessage) {
            vm.$store.dispatch("updateLoading", false);
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.personList.splice(personIndex, 1, response.data.Data.FlowManage);
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              message: response.data.Data.Message,
              type: "success",
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    openPassModal(arrangeGuid, stageGuid, personIndex, stepName) {
      this.passItem = {
        arrangeGuid: arrangeGuid,
        stageGuid: stageGuid,
        personIndex: personIndex,
        stepName: stepName,
      };
      $("#passModal").modal("show");
    },
    pass() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.passArrange(vm.passItem)
        .then((response) => {
          if (response.data.ErrorMessage) {
            vm.$store.dispatch("updateLoading", false);
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.personList.splice(
              vm.passItem.personIndex,
              1,
              response.data.Data.FlowManage
            );
            vm.$store.dispatch("updateLoading", false);

            vm.$notify({
              message: response.data.Data.Message,
              type: "success",
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
      $("#passModal").modal("hide");
    },

    showTip(person) {
      this.currentPerson = person;
      $("#alertModal").modal("show");
    },

    selectStage(person, personIndex) {
      const vm = this;
      vm.currentPerson = {
        ...person,
        personIndex: personIndex,
      };
      vm.$api.InterviewSch.getInsertStage(person.Guid)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.extraStage = null;
            vm.stageList = response.data.Data;

            $("#stepModal").modal("show");
          }
        })
        .catch((error) => {
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    addStage() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        arrangeGuid: vm.currentPerson.Guid,
        stageGuid: vm.extraStage,
      };
      vm.$api.InterviewSch.insertStage(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            vm.$store.dispatch("updateLoading", false);
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.personList.splice(
              vm.currentPerson.personIndex,
              1,
              response.data.Data.FlowManage
            );
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              message: response.data.Data.Message,
              type: "success",
            });
            $("#stepModal").modal("hide");
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    //取得時段
    getTimePeriodOptions() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getTimePeriodOptions()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.timePeriodOptions = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    showDangerEndModal(person, personIndex) {
      const vm = this;
      this.currentPerson = {
        ...person,
        personIndex: personIndex,
      };
      vm.cancelModal = {};
      $("#dangerEndModal").modal("show");
    },

    showEndModal(person, personIndex) {
      const vm = this;
      this.currentPerson = {
        ...person,
        personIndex: personIndex,
      };
      vm.cancelModal = {};
      $("#endModal").modal("show");
    },

    //取得列表
    getFlowManage() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        ...vm.search,
        ResumeType: null,
      };

      if (vm.activeName === "IDL") {
        params.ResumeType = 1;
      } else if (vm.activeName === "DL") {
        params.ResumeType = 0;
      }

      vm.$api.InterviewSch.getFlowManage(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.personList = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    //取得結案原因
    getCancelReason() {
      const vm = this;

      vm.$api.InterviewSch.getCancelReason()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.cancelReasonList = response.data.Data;
          }
        })
        .catch((error) => {
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    //結案
    finishArrange(type) {
      const vm = this;
      let params = {
        ...vm.cancelModal,
        arrangeGuid: vm.currentPerson.Guid,
      };

      vm.$api.InterviewSch.finishArrange(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.personList.splice(
              vm.currentPerson.personIndex,
              1,
              response.data.Data.FlowManage
            );
            vm.$notify({
              message: response.data.Data.Message,
              type: "success",
            });
            if (type === "normal") {
              $("#endModal").modal("hide");
            } else {
              $("#dangerEndModal").modal("hide");
            }
          }
        })
        .catch((error) => {
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    //取得面談人員選項
    getSupervisor() {
      const vm = this;

      vm.$api.InterviewSch.getSupervisor()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.supervisorList = response.data.Data;
          }
        })
        .catch((error) => {
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    setTempSupervisor(e, superVisorGuid) {
      const vm = this;
      if (e) {
        vm.tempSupervisor = superVisorGuid;
      }
    },

    changeSupervisor(SupervisorGuid, ArrangeGuid, StageGuid, personIndex, stepIndex) {
      const vm = this;
      let params = {
        SupervisorGuid: SupervisorGuid,
        ArrangeGuid: ArrangeGuid,
        StageGuid: StageGuid,
      };

      vm.$api.InterviewSch.setSupervisor(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            vm.personList[personIndex].Stages[stepIndex].InterviewSupervisorGuid =
              vm.tempSupervisor;
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.personList.splice(personIndex, 1, response.data.Data.FlowManage);
            this.$notify({
              message: response.data.Data.Message,
              type: "success",
            });
          }
        })
        .catch((error) => {
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    saveTransfer() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        ...vm.transferModal,
        arrangeGuid: vm.currentPerson.Guid,
      };

      vm.$api.InterviewSch.transferArrange(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            vm.$store.dispatch("updateLoading", false);
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              message: response.data.Data.Message,
              type: "success",
            });
            $("#transferModal").modal("hide");
            vm.getFlowManage();
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    async showTransferModal(person, personIndex) {
      const vm = this;
      this.currentPerson = {
        ...person,
        personIndex: personIndex,
      };

      vm.$store.dispatch("updateLoading", true);
      vm.flowOptions = await vm.getFlowOptions();
      vm.positionOptions = await vm.getPosition();
      vm.contactOptions = await vm.getContactOptions();
      vm.$store.dispatch("updateLoading", false);
      vm.transferModal = {};

      $("#transferModal").modal("show");
      vm.$refs.transferModalForm.reset();
    },

    getFlowOptions() {
      const vm = this;

      return new Promise((resolve, reject) => {
        vm.$api.InterviewSch.getFlowOptions()
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {
              resolve(response.data.Data);
            }
          })
          .catch((error) => {
            this.$notify({
              title: "錯誤",
              message: error.response.data.ErrorMessage,
              type: "error",
            });
            reject(error);
          });
      });
    },
    getPosition() {
      const vm = this;

      return new Promise((resolve, reject) => {
        vm.$api.InterviewSch.getPosition()
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {
              resolve(response.data.Data);
            }
          })
          .catch((error) => {
            this.$notify({
              title: "錯誤",
              message: error.response.data.ErrorMessage,
              type: "error",
            });
            reject(error);
          });
      });
    },

    getContactOptions() {
      const vm = this;
      return new Promise((resolve, reject) => {
        vm.$api.InterviewSch.getContactOptions()
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {
              resolve(response.data.Data);
            }
          })
          .catch((error) => {
            this.$notify({
              title: "錯誤",
              message: error.response.data.ErrorMessage,
              type: "error",
            });
            reject(error);
          });
      });
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    moment: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD HH:mm");
      }
    },
    momentTime: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("HH:mm");
      }
    },
  },

  created() {
    this.getFlowManage();
    this.getCancelReason();
    this.getTimePeriodOptions();
    this.getSupervisor();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.p-row {
  margin-bottom: 10px;
  background-color: #fff;
  padding: 5px;
  border-radius: 5px;
  align-items: center;
  white-space: nowrap;
  display: flex;

  .info {
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    .name-link {
      font-weight: bold;
      cursor: pointer;
      background-color: #f8f2a0;
      border-radius: 25px;
      width: 100px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      &.female {
        background-color: #ffd4d4;
      }

      &.male {
        background-color: #d9e3ff;
      }
    }
    .id {
      font-size: 0.8em;
      width: 100px;
    }
    .job {
      font-size: 0.8em;
      background: #5380f7;
      width: 100px;
      display: block;
      color: #fff;
      padding: 3px 5px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .flow {
    flex: 1;
    min-width: 1px;
    overflow-x: auto;
    .flow-group {
      display: inline-block;
      vertical-align: middle;
      list-style: none;
      margin-bottom: 0;
      padding: 0;
      .flow-item {
        display: inline-block;
        min-height: 90px;
        vertical-align: top;
        background-color: rgb(247, 247, 247);
        padding: 10px;
        margin-left: 5px;
        border: 2px solid #ccc;
        border-radius: 3px;
        position: relative;
        white-space: nowrap;

        .step-name {
          display: inline-block;
          margin-right: 3px;
          margin-bottom: 0;
          line-height: 38px;
          vertical-align: middle;
          font-size: 0.8em;

          &.line-through {
            text-decoration: line-through;
          }
        }

        &.undo {
          cursor: pointer;
          background-color: #d9e3ff;
          border-color: #5380f7;
        }

        &.meeting {
          background-color: #fdc7c7;
          border-color: #db7272;
        }
        &.finish {
          background-color: rgb(247, 247, 247) !important;
          border: 2px solid #ccc !important;
        }

        .time-wrap {
          font-size: 0.9em;
          display: inline-block;
          vertical-align: top;
        }

        .pass-tip {
          background-color: #e6e6e6;
          padding: 3px 11px;
          border-radius: 25px;
          font-size: 0.8em;
        }
      }
    }

    &::-webkit-scrollbar {
      height: 7px;
      @media screen and (max-width: 767px) {
        height: 20px;
      }
    }
    &::-webkit-scrollbar-button {
      background: transparent;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.4);
      border: 1px solid slategrey;
    }
    &::-webkit-scrollbar-track {
      box-shadow: transparent;
    }
  }

  .ghost {
    opacity: 0.5;
    &::before {
      display: none;
    }
  }
}
</style>
